import { render, staticRenderFns } from "./PurchaseOrderDetailSelect.vue?vue&type=template&id=5b838586&"
import script from "./PurchaseOrderDetailSelect.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetailSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports